// BoxHeader.tsx
import { Button, Box, Typography, Tabs, Tab, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "../Styles/Formstyles.css";
import AddIcon from "@mui/icons-material/Add";
interface BoxHeaderProps {
  dashboard_name: string;
  image?: string;

  // Button
  button_name?: string;
  button_show?: boolean;
  onAdd?: () => void;

  // Tabs
  tabs?: string[];
  activeTab?: number;
  onTabChange?: (newValue: number) => void;
}

const BoxHeader: React.FC<BoxHeaderProps> = ({
  dashboard_name,
  image,
  button_name,
  button_show,
  onAdd,
  tabs,
  activeTab = 0,
  onTabChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–959px

  const stackLayout = isMobile || isTablet; // stack on mobile & tablet

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: stackLayout ? "column" : "row",
        justifyContent: stackLayout ? "flex-start" : "space-between",
        alignItems: stackLayout ? "flex-start" : "center",
        gap: stackLayout ? 2 : 0,
        mb: 3,
      }}
    >
      {/* Title */}
      <Box  sx={{ display: "flex", alignItems: "center", gap: 1 , mb: stackLayout ? 1.5 : 0, 
    mr: !stackLayout ? 3 : 0,}}>
        {image && <img src={image} alt={dashboard_name} width={20} height={20} />}
        <Typography
  className="header"
  variant={isMobile ? "h6" : "h5"}
  noWrap={!isMobile}   // prevent wrapping on desktop/tablet
  sx={{
    whiteSpace: "nowrap",    // force in one line
    overflow: "hidden",
    textOverflow: "ellipsis", // in case it's too long
  }}
>
  {dashboard_name}
</Typography>
      </Box>

      {/* Tabs + Button (collapsed on tablet/mobile) */}
      <Box
        sx={{
          display: "flex",
          flexDirection: stackLayout ? "column" : "row",
          alignItems: stackLayout ? "flex-start" : "center",
          gap: 2,
          width: "100%",
        }}
      >
        {/* Tabs */}
        {tabs && tabs.length > 0 && (
        <Tabs
  value={activeTab}
  onChange={(_e, newValue) => onTabChange?.(newValue)}
  variant={isMobile ? "scrollable" : "standard"}
  scrollButtons={isMobile ? "auto" : false}
  TabIndicatorProps={{ style: { display: "none" } }} 
  sx={{ minHeight: 36, flex: 1 }}
>
  {tabs.map((label, index) => (
    <Tab
      key={index}
      disableRipple
      label={
        <span
          className={`app-tab-label ${activeTab === index ? "active" : ""}`}
        >
          {label}
        </span>
      }
      sx={{ minHeight: 36 }}
    />
  ))}
</Tabs>

        )}

        {/* Button */}
        {button_show && button_name && (
         <Button
  className="btn-primary"
  variant="contained"
  color="primary"
  onClick={onAdd}
  fullWidth={isMobile}
  startIcon={<AddIcon />}   
>
  {button_name}
</Button>
        )}
      </Box>
    </Box>
  );
};

export default BoxHeader;
